import { ValueMap } from '../model/value-map.js';
/**
 * A number range constraint that cannot be undefined. Used for slider control.
 */
export class DefiniteRangeConstraint {
    constructor(config) {
        this.values = ValueMap.fromObject({
            max: config.max,
            min: config.min,
        });
    }
    constrain(value) {
        const max = this.values.get('max');
        const min = this.values.get('min');
        return Math.min(Math.max(value, min), max);
    }
}
